import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin, faMediumM, faMastodon } from '@fortawesome/free-brands-svg-icons';
import '../SocialMediaLinks.css';

const socialMediaData = [
    {
        href: "https://github.com/Piyush-Bhor",
        icon: faGithub,
        alt: "GitHub"
    },
    {
        href: "https://www.linkedin.com/in/piyush-b-bb7394265/",
        icon: faLinkedin,
        alt: "LinkedIn"
    },
    {
        href: "https://medium.com/@piyushbhor22",
        icon: faMediumM,
        alt: "Medium"
    },
    {
        href: "https://infosec.exchange/@The_Kernel_Panic",
        icon: faMastodon,
        alt: "Mastodon"
    }
];

const SocialMediaLinks = () => {
    return (
        <div className="social-media">
            <div className="social-links">
                {socialMediaData.map((media, index) => (
                    <a key={index} href={media.href} target="_blank" rel="noopener noreferrer" aria-label={media.alt}>
                        <FontAwesomeIcon icon={media.icon} size="1x" />
                    </a>
                ))}
            </div>
            <div className="copyright">
                &copy; 2024 Piyush Bhor. Made with  <span role="img" aria-label="love">❤️</span>
            </div>
        </div>
    );
}

export default SocialMediaLinks;



// WEBPACK FOOTER //
// ./src/components/Social_Media_Links.js